var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.loadingScreen}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":""}})],1),_c(_vm.tabs[_vm.usersRole],{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }